import apiFetech from "../configs/axios";
import { API_POINT_DOMAIN } from "../constants/urls";

export class ProviderServices {
  static getRate() {
    var config = {
      method: "GET",
      url: "provider_rate?rate=0"
    };
    return apiFetech(config);
  }

  static getAll() {
    var config = {
      method: "GET",
      url: "index/provider"
    };
    return apiFetech(config);
  }
  static getNextPage(url) {
    var config = {
      method: "GET",
      url: `${url.replace(`${API_POINT_DOMAIN}`, '')}`
    };
    return apiFetech(config);
  }

  static getMealsProvider(id) {
    var config = {
      method: "GET",
      url: `meal/provider/${id}`
    };
    return apiFetech(config);
  }

  // Get Provider By Filtering
  static getFilterProvider({filter,city_id=0}) {
    var config = {
      method: "GET",
      url: `search/city_id/${city_id}/providers${filter}`
      ,headers:{city_id}
    };
    return apiFetech(config);
  }

  // Get Search providers by name
  static  searchProvider({name,city_id=0})  {
    var config = {
      method: "GET",
      url: `search/city_id/${city_id}/provider?name=${name}`
    };
    return apiFetech(config);
  }
}
